'use client';

// Next Imports
import { redirect, usePathname } from 'next/navigation';

// Config Imports
import themeConfig from '@configs/themeConfig';

const AuthRedirect = () => {
    const pathname = usePathname();

    // ℹ️ Bring me `lang`
    const redirectUrl = `/login?redirectTo=${pathname}`;
    const login = `/login`;
    const homePage = themeConfig.homePageUrl;

    let redirectTo = redirectUrl;

    if (pathname === login) {
        redirectTo = login;
    } else if (pathname === homePage) {
        redirectTo = login;
    }

    return redirect(redirectTo);
};

export default AuthRedirect;
